export default __webpack_public_path__ + "static/arrow-green-down-90d073fec821d22094ac0584b8fe7154.png";